export default __webpack_public_path__ + "static/media/poster.f671ec74.jpg";